<template>
	<v-col class="sponsorisasi">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Genealogy</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-account-group</v-icon>
			<div class="pl-2">Jaringan</div>
			<div class="px-2">/</div>
			<div>Genealogy</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12" sm="6" md="5">
					<div class="d-flex">
						<v-text-field placeholder="Kode Mitra" outlined dense background-color="white" class="rounded-lg date-no-border" hide-details v-model="code_member"></v-text-field>
						<v-btn depressed height="40" color="primary" class="ml-2 mx-sm-3 white--text rounded-lg text-capitalize" @click="searchGene">
							<span>Cari</span>
						</v-btn>
					</div>
				</v-col>

				<template v-if="!loading">
					<v-col cols="12" sm="12" md="12" v-if="listGenealogy.length > 0">
						<div class="d-block d-md-none mb-5">
							<div v-if="listGenealogy[0].network_code" class="d-flex flex-column align-center justify-centermb-4">
								<v-btn outlined block color="primary" class="pl-2 pr-2 mb-2 text-capitalize" @click="getGenealogyByNode(listGenealogy[0].network_sponsor_network_code), code_member = ''">
									<v-icon>mdi-chevron-left</v-icon>
									<span>Lihat Jaringan Sebelumnya</span>
								</v-btn>
								<v-btn outlined block color="primary" class="pl-2 pr-2 text-capitalize" @click="getGenealogyByNode(userData.member_ref_network_code), code_member = ''">
									<v-icon>mdi-account-network</v-icon>
									<span class="pl-1">Lihat Jaringan Saya</span>
								</v-btn>
							</div>
						</div>

						<div class="d-none d-md-block mb-5">
							<div v-if="listGenealogy[0].network_code != userData.member_ref_network_code" class="d-flex flex-row align-center justify-space-between mb-4">
								<v-btn outlined color="primary" class="pl-2 pr-2 text-capitalize" @click="getGenealogyByNode(listGenealogy[0].network_sponsor_network_code), code_member = ''">
									<v-icon>mdi-chevron-left</v-icon>
									<span>Lihat Jaringan Sebelumnya</span>
								</v-btn>
								<v-btn outlined color="primary" class="pl-2 pr-2 text-capitalize" @click="getGenealogyByNode(userData.member_ref_network_code), code_member = ''">
									<v-icon>mdi-account-network</v-icon>
									<span class="pl-1">Lihat Jaringan Saya</span>
								</v-btn>
							</div>
						</div>

						<template>
							<v-row>
								<v-col cols="12">
									<v-card>
										<v-row
											class="pa-4"
											justify="space-between"
										>
											<v-col cols="12">
												<div id="treeview-chart">
													<!-- :class="{'has-last-single-node': listGenealogy[0].children && listGenealogy[0].children[listGenealogy[0].children.length - 1].children.length === 1}" -->
													<ul class="group-node root">
														<template v-for="(node1, ida) in listGenealogy">
															<li :key="ida" :class="{'has-last-single-node': listGenealogy.children && listGenealogy.children[listGenealogy.children.length - 1].children.length === 1}">
																<div class="d-flex flex-row align-center" style="height: 55px;">
																	<CardMember :data="node1" @action="generateGene(node1.network_code)"></CardMember>
																	<CardLoader :data="node1" @action="loadmore(node1.network_code)" v-if="node1.children_more"></CardLoader>
																</div>
																<template v-if="node1.children && node1.children.length > 0">
																	<v-btn
																		fab
																		dark
																		dense
																		x-small
																		color="#2F8E94"
																		outlined
																		elevation="0"
																		title="Tampilkan downline..."
																		style="background: white;"
																		class="btn-show"
																		@click="expandNode($event)"
																	>
																		<v-icon dark>mdi-minus</v-icon>
																	</v-btn>
																</template>
																<ul class="group-node first" :class="{'has-last-single-node': node1.children[node1.children.length - 1].children.length === 1}" v-if="node1.children.length > 0">
																	<template v-for="(node2, idb) in node1.children">
																		<li :key="idb" :class="{'single-node': node2.children.length === 1}">
																			<div class="d-flex flex-row align-center" style="height: 55px;">
																				<CardMember :data="node2" @action="generateGene(node2.network_code)"></CardMember>
																				<CardLoader :data="node2" @action="loadmore(node2.network_code)" v-if="node2.children_more"></CardLoader>
																			</div>
																			<template v-if="node2.children && node2.children.length > 0">
																				<v-btn
																					fab
																					dark
																					dense
																					x-small
																					color="#2F8E94"
																					outlined
																					elevation="0"
																					title="Tampilkan downline..."
																					style="background: white;"
																					class="btn-show"
																					@click="expandNode($event)"
																				>
																					<v-icon dark>
																						mdi-minus
																					</v-icon>
																				</v-btn>
																			</template>
																			<ul class="group-node second" v-if="node2.children.length > 0">
																				<template v-for="(node3, idc) in node2.children">
																					<li :key="idc" :class="{'single-node': node3.children.length === 1}">
																						<div class="d-flex flex-row align-center" style="height: 55px;">
																							<CardMember :data="node3" @action="generateGene"></CardMember>
																							<CardLoader :data="node3" @action="loadmore(node3.network_code)" v-if="node3.children_more"></CardLoader>
																						</div>
																						<template v-if="node3.children && node3.children.length > 0">
																							<v-btn
																								fab
																								dark
																								dense
																								x-small
																								color="#2F8E94"
																								outlined
																								elevation="0"
																								title="Tampilkan downline..."
																								style="background: white;"
																								class="btn-show"
																								@click="expandNode($event)"
																							>
																								<v-icon dark>
																									mdi-minus
																								</v-icon>
																							</v-btn>
																						</template>
																						<ul class="group-node third" v-if="node3.children.length > 0">
																							<template v-for="(node4, idd) in node3.children">
																								<li :key="idd"><CardMember :data="node4" @action="generateGene"></CardMember></li>
																							</template>
																						</ul>
																					</li>
																				</template>
																			</ul>
																		</li>
																	</template>
																</ul>
															</li>
														</template>
													</ul>
												</div>
											</v-col>

										</v-row>
									</v-card>
								</v-col>
							</v-row>
						</template>
					</v-col>

					<v-col cols="12" sm="12" md="12" v-else>
						<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
							<NoData></NoData>
							<div class="pt-3 text-center cl-secondary">Tidak ada data mitra yang dapat ditampilkan</div>
							<div class="pt-3 mb-4 text-center">
								<v-btn outlined color="primary" class="pl-2 pr-2 text-capitalize" @click="getGenealogyByNode(userData.member_ref_network_code)">
									<v-icon>mdi-account-network-outline</v-icon>
									<span class="pl-1">Kembali ke Jaringan Saya</span>
								</v-btn>
							</div>
						</v-card>
					</v-col>
				</template>

				<template v-else>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</template>
			</v-row>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CardMember from './components/CardMember';
import CardLoader from './components/CardLoader';

const pause = ms => new Promise(resolve => setTimeout(resolve, ms))

export default {
	components: {
		CardMember,
		CardLoader
	},
	data() {
		return {
			loading: false,
			code_member: '',
			isMobile: false,
			activeNode: [],
      avatar: null,
      open: [],
      users: [],
			listGenealogy: [],
			offsets: 0,
			items: [
				// {
				// 		"network_id":"31",
				// 		"network_code":"BM10000017",
				// 		"member_name":"September",
				// 		"member_image":"",
				// 		"network_type":"Sahabat",
				// 		"network_activation_datetime":"2021-11-03 11:19:07",
				// 		"network_sponsor_network_code":"BM10000016",
				// 		"level":3,
				// 		"children": []
				// },
				// {
				// 		"network_id":"32",
				// 		"network_code":"BM10000018",
				// 		"member_name":"Oktober",
				// 		"member_image":"",
				// 		"network_type":"Sahabat",
				// 		"network_activation_datetime":"2021-11-03 11:23:19",
				// 		"network_sponsor_network_code":"BM10000016",
				// 		"level":3,
				// 		"children": []
				// },
				// {
				// 		"network_id":"46",
				// 		"network_code":"BM10000030",
				// 		"member_name":"Maret",
				// 		"member_image":"",
				// 		"network_type":"Sahabat",
				// 		"network_activation_datetime":"2021-11-05 15:59:25",
				// 		"network_sponsor_network_code":"BM10000016",
				// 		"level":3,
				// 		"children": []
				// },
				// {
				// 		"network_id":"47",
				// 		"network_code":"BM10000031",
				// 		"member_name":"April",
				// 		"member_image":"",
				// 		"network_type":"Duta",
				// 		"network_activation_datetime":"2021-11-05 16:17:24",
				// 		"network_sponsor_network_code":"BM10000016",
				// 		"level":3,
				// 		"children": []
				// },
				// {
				// 		"network_id":"48",
				// 		"network_code":"BM10000032",
				// 		"member_name":"mei",
				// 		"member_image":"",
				// 		"network_type":"Juragan",
				// 		"network_activation_datetime":"2021-11-05 16:47:21",
				// 		"network_sponsor_network_code":"BM10000016",
				// 		"level":3,
				// 		"children": []
				// },
				// {
				// 		"network_id":"49",
				// 		"network_code":"BM10000033",
				// 		"member_name":"juni",
				// 		"member_image":"https://balmed.esoftdream.co.id/uploads/images/profile/1636106287_5961570f0980b3bddac3.jpg",
				// 		"network_type":"Sultan",
				// 		"network_activation_datetime":"2021-11-05 16:54:22",
				// 		"network_sponsor_network_code":"BM10000016",
				// 		"level":3,
				// 		"children": []
				// }
			]
		}
	},
	computed: {
		// ...mapState('profile', ['myProfile']),
		...mapState('auth', ['userData']),
		...mapState('network', ['dataGenealogy']),
		// listGenealogy() {
		// 	return [
		// 		{
		// 			name: 'Users',
		// 			children: this.users,
		// 		},
		// 	]
		// },
		// selected () {
		// 	if (!this.active.length) return undefined

		// 	const id = this.activeNode[0]
		// 	return this.users.find(user => user.id === id)
		// },
		
		windowWidth() {
      return this.getWindowWidth()
		}
	},
	watch: {
	},
	methods: {
		...mapActions('network', ['getGenealogy', 'getGenealogyChilds']),

		getWindowWidth() {
      let screen = document.documentElement.clientWidth
      if (screen <= 767) this.isMobile = true
      else this.isMobile = false
		},
		getGenealogyByNode(code) {
			this.loading = true
			this.listGenealogy = []
			this.getGenealogy({parent: code, limit: 10, offset: 0}).then(() => {
				const data = this.dataGenealogy
				if (data.length == 0) this.listGenealogy = new Array()
				else this.listGenealogy = new Array(data)
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				setTimeout(() => {
					this.loading = false
				}, 1000);
			}).catch(() => {
				this.loading = false
			})
		},
		searchGene() {
			const code = this.code_member
			this.getGenealogyByNode(this.code_member)
			this.code_member = code
		},
		generateGene(kode) {
			this.getGenealogyByNode(kode)
			this.code_member = ''
		},

		async loadmore(parent) {
			// this.loading = await true
			await pause(1500)
			// console.log(parent)
			await this.getOffsetChild(parent)
			// console.log('limit', this.offsets)
			let datacharts = await this.listGenealogy

			this.getGenealogyChilds({parent: parent, limit: 10, offset: (parseInt(this.offsets) + 1)}).then((response) => {
				const newChilds = response.results.data.children
				// console.log('getGenealogyChilds', response.results.data)
				datacharts.forEach((node1) => {
					// console.log('items', newChilds.length)
					if (parent === node1.network_code) {
						node1.children_more = response.results.data.children_more
						newChilds.forEach((nodeItems) => {
							node1.children.push(nodeItems)
						})
					}
					else {
						if (node1.children.length > 0) {
							node1.children.forEach((node2) => {
								if (parent === node2.network_code) {
									node2.children_more = response.results.data.children_more
									newChilds.forEach((nodeItems) => {
										node2.children.push(nodeItems)
									})
								}
								else {
									if (node2.children.length > 0) {
										node2.children.forEach((node3) => {
											if (parent === node3.network_code) {
												node3.children_more = response.results.data.children_more
												newChilds.forEach((nodeItems) => {
													node3.children.push(nodeItems)
												})
											}
										})
									}
								}
							})
						}
					}
				});

				// console.log('datacharts', datacharts)

				this.listGenealogy = datacharts
				this.loading = false
			}).catch((error) => {
				console.log(error)
				this.loading = false
			})

			// console.log('datacharts', datacharts)
		},

		getOffsetChild(kode) {
			this.listGenealogy.forEach((node1) => {
				if (kode === node1.network_code) this.offsets = node1.children.length
				else {
					if (node1.children.length > 0) {
						node1.children.forEach((node2) => {
							if (kode === node2.network_code) this.offsets = node2.children.length
							else {
								if (node2.children.length > 0) {
									node2.children.forEach((node3) => {
										if (kode === node3.network_code) this.offsets = node3.children.length
									})
								}
							}
						})
					}
				}
			});
		},

		expandNode(event) {
			// console.log('expandNode', event.target.parentElement.parentElement.parentElement)
			const parents = event.target.parentElement.parentElement.parentElement
			parents.classList.toggle('collapsed')
			if(event.target.classList.contains('mdi')) event.target.classList.toggle('mdi-plus')
		},

		async loadMember(code) {
			this.getGenealogy({parent: code, limit: 10, offset: 0}).then(() => {
				const data = this.dataGenealogy
				this.listGenealogy = new Array(data)
				setTimeout(() => {
					this.loading = false
				}, 1000);
			}).catch(() => {
				this.loading = false
			})
		},
	},
	async created(){
		await this.$store.dispatch('setPageTitle', `Genealogy`)
		await this.getWindowWidth()
		await window.addEventListener('resize', this.getWindowWidth)
		this.loading = await true
		// this.fetchUsers()
		if (this.userData) this.loadMember(this.userData.member_ref_network_code)
	},
  destroyed() {
    window.addEventListener('resize', this.getWindowWidth)
  }
};
</script>

<style lang="scss" scoped>
	#treeview-chart {
		display: inline-block;
		position: relative;
		.group-node {
			display: block;
			position: relative;
			padding-left: 60px;
			list-style: none;

			li {
				display: block;
				position: relative;
				margin: 10px 0;

				&::before {
					height: calc(100% - 70px);
					display: block;
					width: 0.5px;
					background: #888;
					position: absolute;
					left: 32px;
					top: 43px;
					z-index: 0;
					content: "";
					// display: none;
				}

				&::after {
					height: 0.5px;
					display: block;
					width: 30px;
					background: #888;
					position: absolute;
					left: -28px;
					top: 27px;
					z-index: 0;
					content: "";
				}

				&.single-node {
					&::before {
						height: calc(100% - 70px);
						display: block;
						width: 0.5px;
						background: #888;
						position: absolute;
						left: 32px;
						top: 43px;
						z-index: 0;
						content: "";
						// display: none;
					}

					&::after {
						height: 0.5px;
						display: block;
						width: 30px;
						background: #888;
						position: absolute;
						left: -28px;
						top: 27px;
						z-index: 0;
						content: "";
					}

					& > .group-node::before {
						height: calc(100% - 50px);
						display: block;
						width: 0.5px;
						background: #FFF;
						position: absolute;
						left: 32px;
						top: 28px;
						z-index: 0;
						content: "";
					}

					&:last-child {
						&::before {
							height: 50px;
							display: block;
							width: 0.5px;
							background: #888;
							position: absolute;
							left: 32px;
							top: 43px;
							z-index: 0;
							content: "";
							// display: none;
						}

						.group-node::before {
							height: calc(100% - 50px);
							display: block;
							width: 0.5px;
							background: #FFF;
							position: absolute;
							left: 32px;
							top: 28px;
							z-index: 0;
							content: "";
						}
					}
				}

				&.collapsed {
					ul {
						display: none;
					}

					&:last-child::before {
						display: none;
					}
				}
			}

			&.root { 
				padding-left: 15px;

				& > li {
					&::before {
						
					}
					&::after {
						display: none
					}
				}
			}
		}

		.has-last-single-node {
			.single-node:last-child {
				ul.group-node {
					&:before {
						height: calc(100% + 20px)!important;
						display: block!important;
						width: 0.5px!important;
						background: #FFF!important;
						position: absolute!important;
						left: -28px!important;
						top: -37px!important;
						z-index: 0!important;
						content: ""!important;
					}
				}
			}
		}
	}

	.btn-show {
		height: 24px;
		width: 24px;
		position: absolute;
		top: 16px;
		left: -13px;
		z-index: 5;
	}
</style>